import { render } from "./SEOView.vue?vue&type=template&id=17464396&scoped=true&ts=true&lang=pug"
import script from "./SEOView.vue?vue&type=script&lang=ts"
export * from "./SEOView.vue?vue&type=script&lang=ts"

import "./SEOView.vue?vue&type=style&index=0&id=17464396&lang=scss&scoped=true"

import exportComponent from "/Users/danielwu/Documents/bearathome/bat-project/bat-org-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17464396"]])

export default __exports__